import React from 'react';

const BislitLogo = ({ width = 60, height = 60 }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background circle */}
      <circle cx="50" cy="50" r="48" fill="white" fillOpacity="0.95"/>
      
      {/* Stylized "B" with news feed lines */}
      <path 
        d="M30 30 L30 70 L50 70 C58 70 62 66 62 58 C62 53 59 50 55 49 C58 48 60 45 60 40 C60 33 56 30 48 30 L30 30 Z M38 36 L47 36 C50 36 52 38 52 41 C52 44 50 46 47 46 L38 46 L38 36 Z M38 52 L49 52 C52 52 54 54 54 58 C54 62 52 64 49 64 L38 64 L38 52 Z" 
        fill="#667eea"
      />
      
      {/* News feed lines on the right */}
      <line x1="68" y1="35" x2="85" y2="35" stroke="#764ba2" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="68" y1="43" x2="82" y2="43" stroke="#764ba2" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="68" y1="51" x2="85" y2="51" stroke="#764ba2" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="68" y1="59" x2="80" y2="59" stroke="#764ba2" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="68" y1="67" x2="85" y2="67" stroke="#764ba2" strokeWidth="2.5" strokeLinecap="round"/>
    </svg>
  );
};

export default BislitLogo;
